<loading-layout #loadingLayout>
    <table-with-depending-actions
        [contentArray]="instrumentos"
        [showParams]="params"
        [tableButtonsArray]="tableButtonsArray"
    ></table-with-depending-actions>
    <paginator [getList]="this.showAll.bind(this)"></paginator>
</loading-layout>
